// extracted by mini-css-extract-plugin
export var dialog = "NU+ST";
export var main = "_5psht";